import React from 'react';
import OperatorWizard from './OperatorWizard';

/**
 * One entry point, one screen, for adding an operator and for changing one.
 *
 * BOTH are `OperatorWizard`: the same four sections — the company, billing,
 * settings, and a last one that says what will be sent — over the same field
 * groups from `OperatorFields`, with the save live on every section. Fifteen
 * boxes in one column is an unpleasant way to meet a record whether you are
 * filling it in or fixing one field of it, so neither screen does that.
 *
 * They match because the difficulty is the same on both: fifteen boxes is
 * too many to take in at once, and the sections are how the record is broken
 * into parts a person can hold in their head. What differs is only what the
 * sections are FOR — create numbers them and offers a Next, edit numbers
 * nothing, unlocks everything, says on the rail how full each section is,
 * and ends on what CHANGED rather than on what will be created. Those
 * differences live in `OperatorWizard`, each with its reason beside it.
 *
 * Free waiting time used to be edited here, three boxes on the operator.
 * It is the PARTNER's, not the operator's: the minutes are a sales
 * channel's commercial terms, and the same operator driving a Booking.com
 * job and a Pickup Hungary direct job is on two different agreements. The
 * boxes now live in Partners → Waiting Times
 * (PartnerWaitingTimesModal).
 */
function OperatorInputModal({
  originalOperator = {}, show = false, handleClose, fetchOperators,
}) {
  return (
    <OperatorWizard
      originalOperator={originalOperator}
      show={show}
      handleClose={handleClose}
      fetchOperators={fetchOperators}
    />
  );
}

export default OperatorInputModal;
